<template>
  <div class="w-full">
    <div class="flex flex-col md:flex-row text-xs my-4 items-center justify-center font-medium text-gray-600">
      <p class="md:mb-0 mb-2">&copy; {{ year }} Financial Cents, LLC. All rights reserved.</p>
      <a
        href="/privacy-policy"
        class="ml-1 hover:text-primary-700 underline"
        target="_blank"
      >
        Privacy Policy </a
      >.
      <a
        href="/terms-of-use"
        class="ml-1 hover:text-primary-700 underline"
        target="_blank"
      >
        Terms of Use </a
      >.
    </div>
  </div>
</template>

<script>
export default {
  name: "PortalFooter",

  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style scoped></style>
